/** 가입 단계별 입력 오류를 GA로 보내 어느 칸에서 막히는지 측정한다 */
export const trackSignupFieldError = (step: number, field: string) => {
  window.dataLayer?.push({ event: 'sign_up_field_error', step, field });
};
